<template>
  <div class="has-padding side-panel__portfolio-usage">
    <loading v-if="loading" style="margin-left: 50px;"/>
    <template v-else-if="usage">
      <p class="guide_text side-panel__portfolio-usage__intro">
        Where this portfolio is referenced elsewhere in the ecosystem.
      </p>

      <div class="usage-section" v-for="section in usedSections" :key="section.key">
        <div class="usage-section__header">
          <icon class="usage-section__icon" :name="section.icon"/>
          <h4 class="usage-section__title">{{ section.label }}</h4>
          <span class="usage-section__count">{{ usage[section.key].length }}</span>
        </div>
        <ul class="usage-section__list">
          <li v-for="item in usage[section.key]" :key="item.id">
            <router-link class="usage-section__link" :to="link(section.key, item)" v-if="link(section.key, item)">{{ item.name }}</router-link>
            <span v-else>{{ item.name }}</span>
          </li>
        </ul>
      </div>

      <p class="usage-section__empty-summary" v-if="usedSections.length === 0">
        This portfolio isn't used anywhere else yet.
      </p>
      <p class="usage-section__empty-summary" v-else-if="emptySections.length > 0">
        Not used in: {{ emptySections.map(section => section.label).join(', ') }}
      </p>
    </template>
  </div>
</template>

<script>
  import { getPortfolioUsage } from '../../api/portfolios.js'
  import Loading from '../Dashboard/ConceptMap/Loading.vue'

  export default {
    props: ['portfolioId'],
    data () {
      return {
        loading: true,
        usage: null,
        sections: [
          { key: 'communities', label: 'Communities', icon: 'community' },
          { key: 'spottingAreas', label: 'Spotting Areas', icon: 'compass' },
          { key: 'challenges', label: 'Challenges', icon: 'flag' },
          { key: 'knowledgeBasePosts', label: 'Knowledge Base Posts', icon: 'book' },
          { key: 'conceptSearches', label: 'Saved Searches', icon: 'search' },
          { key: 'reportTemplates', label: 'Report Templates', icon: 'reporting' },
          { key: 'reportSnapshots', label: 'Report Snapshots', icon: 'file-report' },
          { key: 'apiTokens', label: 'API Tokens', icon: 'key' },
          { key: 'permissionPackages', label: 'Permission Packages', icon: 'permissions' },
          { key: 'portfolioSyncs', label: 'Portfolio Syncs', icon: 'sync' },
        ],
      }
    },
    computed: {
      usedSections () {
        return this.sections.filter(section => this.usage[section.key] && this.usage[section.key].length > 0)
      },
      emptySections () {
        return this.sections.filter(section => !this.usage[section.key] || this.usage[section.key].length === 0)
      },
    },
    methods: {
      link (sectionKey, item) {
        switch (sectionKey) {
          case 'communities':
            return `/communities/${item.id}`
          case 'spottingAreas':
            return `/spotting-areas/${item.id}`
          case 'challenges':
            return `/challenges/${item.id}`
          case 'knowledgeBasePosts':
            return `/knowledge-base/posts/${item.id}`
          case 'conceptSearches':
            return `/dashboards/concept-map/${item.id}`
          case 'reportTemplates':
            return '/settings/reporting'
          case 'apiTokens':
            return '/settings/integrations#api-tokens'
          case 'permissionPackages':
            return '/settings/ecosystem-member-packages'
          case 'portfolioSyncs':
            return '/settings/integrations'
          default:
            return null
        }
      },
      fetchUsage () {
        this.loading = true

        getPortfolioUsage(this.portfolioId)
          .then(response => {
            this.usage = response
          })
          .finally(() => {
            this.loading = false
          })
      },
    },
    watch: {
      portfolioId () {
        this.fetchUsage()
      },
    },
    mounted () {
      this.fetchUsage()
    },
    components: {
      Loading,
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../../scss/variables";

  .side-panel__portfolio-usage__intro {
    margin-bottom: 1.5em;
  }

  .usage-section {
    margin-bottom: 1.5em;
    padding-bottom: 1.5em;
    border-bottom: 1px solid $color-borders;

    &:last-of-type {
      border-bottom: none;
    }
  }

  .usage-section__header {
    display: flex;
    align-items: center;
    margin-bottom: 0.5em;
  }

  .usage-section__icon {
    color: $color-primary;
    margin-right: 0.5em;
    font-size: 14px;
  }

  .usage-section__title {
    margin: 0;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: $color-text-grey;
  }

  .usage-section__count {
    margin-left: 0.5em;
    color: $color-text-grey-light;
    font-size: 12px;
  }

  .usage-section__list {
    margin: 0;
    padding-left: 1.7em;
    list-style: disc;
  }

  .usage-section__link {
    color: $color-primary;

    &:hover {
      text-decoration: underline;
    }
  }

  .usage-section__empty-summary {
    color: $color-text-grey-light;
    font-size: 13px;
  }
</style>
